<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrIyilestirmeBirim from "@/models/StrIyilestirmeBirim"; import Swal from "sweetalert2";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
import moment from 'moment'
export default {
  mixins: [Api, Sabit, StrIyilestirmeBirim],
  page: {
    title: "Birim İyileştirmeleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, formcombobox, BirimSecimi
  },
  data() {
    return {
      title: "Birim İyileştirmeleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "İyileştirme İşlemleri",
        },
        {
          text: "Birim İyileştirmeleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
        Donemid: null,
        Durum: null
      },
      Userid: store.getters["auth/TokenUserId"],
      Tarih: moment(new Date()).format('YYYY-MM-DD'),
      FILES_URL: null,
       currentPath: this.$route.path,  
    };
  },

  methods: {
    Get() { this.FilterGet() },
    FilterGet() {

      this.$v.Filter.$touch();
      if (!this.$v.Filter.$invalid) {
        var Filter = ""
        if (this.Filter.Iyilestirmeid != null) { Filter += "&Iyilestirmeid=" + this.Filter.Iyilestirmeid }
        if (this.Filter.Durum != null) { Filter += "&Durum=" + this.Filter.Durum }
        if (this.Filter.Birimid != null) { Filter += "&Birimid=" + this.Filter.Birimid }
        this.ActionsFilterGet({ Service: "StrIyilestirmeBirim/GetBirimIylestirmeleri", Page: this.Page, Filter: Filter }).then((res) => {

          var Data = res.Data;
          for (let index = 0; index < Data.length; index++) {
            const element = Data[index];
            element.Revizyonaciklama = this.TryParseJson(element.Revizyonaciklama)
            element.Kanit = this.TryParseJson(element.Kanit)
          }
          this.TableData = Data;
          this.Page.PageDataSize = res.TotalCount;
        });
      }
    },
    TryParseJson(param) {
      try {
        if (typeof param === "string") {
          return JSON.parse(param);
        }
        if (typeof param === "object" && param !== null) {
          return param;
        }
        return [];
      } catch (e) {
        return [];
      }
    },
    PlanGonder(Data) {
      Swal.fire({
        title: "İyileştirme Planını Gönder ",
        text: "Seçtiğiniz iyileştirme planı gönderilecektir",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Durum = 2
          Data.Revizyonaciklama = JSON.stringify(Data.Revizyonaciklama)
          Data.Kanit = JSON.stringify(Data.Kanit)
          this.Update("StrIyilestirmeBirim", Data, "İyileştirme Planını Gönderildi")
          Data.Revizyonaciklama = JSON.parse(Data.Revizyonaciklama)
          Data.Kanit = JSON.parse(Data.Kanit)
        }
      });

    },
    async Kaydet(Data) {
      Data.Revizyonaciklama = JSON.stringify(Data.Revizyonaciklama)
      Data.Kanit = JSON.stringify(Data.Kanit)
      if (Data.Id == "00000000-0000-0000-0000-000000000000") {
        delete Data.Id
        Data.Durum = 1
        await this.Post("StrIyilestirmeBirim", Data)
        this.FilterGet()
      } else {
        await this.Update("StrIyilestirmeBirim", Data)
        this.FilterGet()

      }
    },

    getRowClass(data) {
      const { Bitisay, Bitisyil, Durum } = data;
      if (!Bitisay || !Bitisyil || Durum == 4) return '';

      const now = new Date();
      const nowMonth = now.getMonth() + 1;
      const nowYear = now.getFullYear();
      if (Bitisyil < nowYear || (Bitisyil == nowYear && Bitisay < nowMonth)) {
        return 'bg-danger ';
      }
      if (Bitisyil == nowYear && Bitisay == nowMonth) {
        console.log("geldi")
        return 'bg-warning';
      }
      return 'bg-info ';
    },


    FileUpload(event, index) {
      var file = event.target.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (
        uzanti == "png" ||
        uzanti == "jpeg" ||
        uzanti == "jpg" ||
        uzanti == "doc" ||
        uzanti == "xml" ||
        uzanti == "pdf" ||
        uzanti == "xlsx"
      ) {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Str",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.TableData[index].Kanit.push({
              'Tarih': this.Tarih,
              'Tip': 'File',
              'Kanit': res.Data.filename
            })
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    openFileInput(index2) {
      const el = this.$refs.file[index2]    
      if (el) el.click()
    },
  
  isLink(text) {
    const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
    return urlPattern.test(text);
  }

  },
  created() {

    this.FILES_URL = this.$config.FILES_URL;
  }
};
</script>
<style scoped>
tbody>tr:nth-of-type(2n) {
  --bs-table-accent-bg: none;
}
</style>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">  
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <formcombobox class="col-md-3" :FormDataType="FormDataType.Iyilestirmeid" :Value="Filter.Iyilestirmeid"
                  :v="$v.Filter.Iyilestirmeid" @input="Filter.Iyilestirmeid = $event" />

                <formcombobox class="col-md-3" :FormDataType="FormDataType.Durum" :Value="Filter.Durum"
                  :v="$v.Filter.Durum" @input="Filter.Durum = $event" />
                <BirimSecimi class="mb-3 col-md-3" :title="FormDataType.Birimid.FieldTitle" :sutun="'0'"
                  :title_position="'mb-3'" :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid"
                  :multiple="false" :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" :YetkiKontrol=1 />

                <div class="col-sm-1 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="FilterGet()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>


                <!--     <div class="col-sm-2 ">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4"
                      v-b-modal.StrIyilestirmeBirim
                      @click="(DataUpdate = StrIyilestirmeBirimData), (AddEdit = 'Add')"><i
                        class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div> -->
              </div>
 
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Dönem</th>
                      <th>Geliştirmeye Açık Yön</th>
                      <th>Durum</th>
                      <th>Revizyon Açıklaması</th>
                      <th>Planlanan İyileştirme</th>
                      <th>Bitiş Ay</th>
                      <th>Bitiş Yıl</th>
                      <th v-if="currentPath == '/StrIyilestirmeKanitBirim'">Kanıt</th>
                      <th v-if="currentPath == '/StrIyilestirmeKanitBirim'">Açıklama</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(Data, index2) in TableData" :key="Data.Id" :class="getRowClass(Data)">
                      <th scope="row">{{ Data.Donem }}</th>
                      <td>{{ Data.Iyilestirme }}</td>
                      <td>{{ DurumEnum[Data.Durum] }}</td>
                      <td>

                        <div class="row" v-for="(value, index) in Data.Revizyonaciklama" :key="index">
                          <b>{{ Data.Revizyonaciklama[index].Tarih }};</b>{{ Data.Revizyonaciklama[index].Aciklama }}
                        </div>
                      </td>
                      <td>
                        <textarea v-model="Data.Planlananiyilestirme" class="form-control"
                          v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false"></textarea>
                        <span v-else> {{ Data.Planlananiyilestirme }}</span>
                      </td>
                      <td>
                        <select v-model="Data.Bitisay" class="form-select"
                          :disabled="Data.Durum == 2 || Data.Durum == 4 ? true : false">
                          <option value="">Seçiniz</option>
                          <option value=1>Ocak</option>
                          <option value=2>Şubat</option>
                          <option value=3>Mart</option>
                          <option value=4>Nisan</option>
                          <option value=5>Mayıs</option>
                          <option value=6>Haziran</option>
                          <option value=7>Temmuz</option>
                          <option value=8>Ağustos</option>
                          <option value=9>Eylül</option>
                          <option value=10>Ekim</option>
                          <option value=11>Kasım</option>
                          <option value=12>Aralık</option>
                        </select>
                      </td>
                      <td><b-form-input v-model="Data.Bitisyil" type="number"
                          :disabled="Data.Durum == 2 || Data.Durum == 4 ? true : false"></b-form-input></td>

                      <td v-if="currentPath == '/StrIyilestirmeKanitBirim'">
                        <div class="row" v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false">
                          <div class="col-md-6"> <input type="file" ref="file" style="display:none"
                              @change="FileUpload($event, index2)" accept=".pdf, .doc, .png" />

                            <i class="fas fa-upload" style="cursor:pointer; font-size:20px;"
                              @click="openFileInput(index2)">
                            </i>
                          </div>
                          <div class="col-md-6">
                            <i v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false" class="fas fa-plus"
                              @click="Data.Kanit.push({ 'Kanit': null, 'Tarih': Tarih, 'Tip': 'Text' });"></i>
                          </div>
                        </div>


                        <div class="row" v-for="(value, index) in Data.Kanit" :key="index">
                          <textarea v-model="value.Kanit" class="form-control" v-if="value.Tip == 'Text' && Data.Durum != 2 && Data.Durum != 4 ? true : false"  ></textarea>
                          <span  v-if="value.Tip == 'Text' && ( Data.Durum == 2 || Data.Durum == 4 )" > 
<a  v-if="isLink(value.Kanit)" :href="value.Kanit"  target="_blank" class="text-primary text-decoration-underline">
        {{ value.Kanit }} </a> 
<span v-else>{{ value.Kanit }}</span> 
                          </span>
                          <a v-if="value.Tip == 'File'" :href="FILES_URL + 'str/' + value.Kanit" target="_blanl">
                            <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i> {{ value.Kanit }}</a>
                        </div>

                      </td>
                      <td v-if="currentPath == '/StrIyilestirmeKanitBirim'">
                        <textarea v-model="Data.Aciklama" class="form-control"
                          v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false"></textarea>
                        <span v-else> {{ Data.Aciklama }}</span>
                      </td>

                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i v-b-tooltip.hover title="Planı Gönder" class="fas fa-paper-plane" @click="PlanGonder(Data)"
                            v-if="Data.Durum == 1 || Data.Durum == 3"></i>
                          <i v-b-tooltip.hover title="Kaydet" class="fas fa-check" @click="Kaydet(Data)" v-if="Data.Durum != 2 && Data.Durum != 4"></i>
                          <i v-b-tooltip.hover title="Sil" class="fas fa-trash-alt" @click="Delete('StrIyilestirmeBirim', Data.Id)"
                            v-if="Data.Id != '00000000-0000-0000-0000-000000000000' && Data.Durum != 2 && Data.Durum != 4"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
